import { generateClient } from "aws-amplify/api";
import { ProjectForResolver } from "db/definitions";
import { batchAddProjects } from "graphql/mutations";
import { recordSentry } from "utils/recordSentry";

/**
 * Given a list of projects, loops through them and puts them in dynamo
 * @author Eric Webb <ewebb@factorearth.com>
 * @param projects The projects we want to put into dynamo
 */
async function batchCreateProjects(projects: ProjectForResolver[]): Promise<boolean> {
	if (projects.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchAddProjects,
				variables: { projects },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchCreateProjects;
